// const mergeComparisonMap = new Map<object, Set<string>>();
/**
 * Stores a Class type, and the value of the Store Name.
 */
const storeNameMap = new Map<object, string>();

//
/**
 * for each `target` (Class object), add to a Set of `keys` (Class property name)
 * @param target    The class, used as the Map Key
 * @param key       The Store Name of the class object.
 */
const storeName = (name: string) => {
  return (target: Function) => {
    const storeNameProperty: string | undefined = storeNameMap.get(
      target.prototype,
    );

    // add entry if doesn't exist. should this throw an error if it already exists ?
    if (!storeNameProperty) {
      storeNameMap.set(target.prototype, name);
    }
  };
};

/**
 *
 * @param target    Instance of a class object. The class __proto__ property is used to
 *                  look up the Store Name value
 * @returns the Store Name
 */
const getStoreName = (target: object): string => {
  // console.log('Target = ' + target + ' getting properties from target');
  const storeNameProperty: string | undefined = storeNameMap.get(
    //@ts-expect-error
    target.__proto__,
  );
  if (!storeNameProperty)
    //@ts-expect-error
    throw new Error(`${target.__proto__} does not have a Store Name value`);
  return storeNameProperty;
};

export { storeName as StoreName, getStoreName };
